module.exports = __webpack_public_path__ + "img/navichevright.f49431ae.svg";